import React from "react";
import { Route, Routes } from "react-router-dom";
import { SellerDashBoard } from "../seller/pages/SellerDashBoard/SellerDashBoard";
import { DashBoard } from "../seller/pages/SellerDashBoard/DashBoard";
import { Products } from "../seller/pages/Products/Products";
import { AddProducts } from "../seller/pages/Products/AddProducts";
import { Orders } from "../seller/pages/Orders/Orders";
import { Profile } from "../seller/pages/Account/Profile";
import { Payment } from "../seller/pages/Payment/Payment";
import { Transaction } from "../seller/pages/Transaction/Transaction";
import { EditProducts } from "../seller/pages/Products/EditProduct";

export const SellerRoutes = () => {
  return (
    <div >
      <Routes>
        {/* chia nho route re nhanh tu seller de de maintain */}
        {/* <Route path="/" element={<DashBoard />} /> */}
        <Route path="/products" element={<Products />} />
        <Route path="/products/edit/:productId" element={<EditProducts />} />
        <Route path="/add-product" element={<AddProducts />} />
        <Route path="/" element={<Orders />} />
        <Route path="/account" element={<Profile  />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/transaction" element={<Transaction />} />
      </Routes>
    </div>
  );
};
